import { List } from "office-ui-fabric-react";

export default class SaleOrder {
  id: number;
  name: string;
  amount_total: number;
  currency_id: List;
  companyId: number;

  static fromJSON(o: Object): SaleOrder {
    const saleOrder = new SaleOrder();
    saleOrder.id = o["id"];
    saleOrder.name = o["name"];
    saleOrder.amount_total = o["amount_total"];
    saleOrder.currency_id = o["currency_id"];
    saleOrder.companyId = o["company_id"];
    return saleOrder;
  }
}
